import { render, staticRenderFns } from "./autoPlay.vue?vue&type=template&id=10128407&scoped=true"
import script from "./autoPlay.vue?vue&type=script&lang=js"
export * from "./autoPlay.vue?vue&type=script&lang=js"
import style0 from "./autoPlay.vue?vue&type=style&index=0&id=10128407&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10128407",
  null
  
)

export default component.exports